import { _ as _objectSpread2 } from '../../dist/transitions-0e124def.esm.js';
import { c as colors, a as components } from '../../dist/colors-04eba91f.esm.js';
export { a as components } from '../../dist/colors-04eba91f.esm.js';
import { headingAliases, headingSizes, textAliases, textSizes, headingPresets, headingCapsizes, textCapsizes, typography as typography$1, radii, sizes, space } from '@hover/blueprint-theme/next';
import { d as defineTextStyles } from '../../dist/textStyles-c6f3986d.esm.js';
import * as tokens from '@hover/tokens-typography/next';
import '@hover/blueprint-theme';
import '@hover/utilities';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/mergeDeepWith';
import '@chakra-ui/theme-tools';
import 'ramda/src/max';
import 'ramda/src/reduce';
import '@chakra-ui/react';
import 'polished';
import '../../dist/button-1b672cc0.esm.js';
import '@hover/tokens-typography';
import '../../dist/toConsumableArray-a674cb10.esm.js';

var textStyles = /*#__PURE__*/defineTextStyles({
  headingAliases: headingAliases,
  headingSizes: headingSizes,
  textAliases: textAliases,
  textSizes: textSizes,
  headingPresets: headingPresets,
  headingCapsizes: headingCapsizes,
  textCapsizes: textCapsizes
});

var typography = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, typography$1), {}, {
  fonts: {
    heading: tokens.familyBrand,
    body: tokens.familyBody,
    mono: tokens.familyCode
  }
});

/**
 * Combined foundations object for use in `extendTheme`
 *
 * @example
 * import { extendTheme } from '@chakra-ui/react';
 * import { foundations } from '.';
 *
 * ```ts
 * const theme = extendTheme({ ...foundations });
 * ```
 */
var foundations = /*#__PURE__*/_objectSpread2({
  colors: colors,
  radii: radii,
  sizes: sizes,
  space: space,
  textStyles: textStyles
}, typography);

var theme = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, foundations), {}, {
  components: components
});

export { foundations, theme };
